var render = function render(){var _vm=this,_c=_vm._self._c;return _c('faqs',{attrs:{"use-filter":"","audiences":[0,1]}})
}
var staticRenderFns = []

export { render, staticRenderFns }